import { Routes, Route } from 'react-router-dom';
import Navbar from './components/Navbar';
import Footer from './components/Footer';
import ScrollToTop from './components/ScrollToTop';

// Sider
import Home from './pages/Home';
import Services from './pages/Services';
import About from './pages/About';
import Prices from './pages/Prices';
import Contact from './pages/Contact';
import NotFound from './pages/NotFound';
import Forbidden from './pages/Forbidden';

export default function App() {
  return (
    <>
      <ScrollToTop />
      <div className="flex flex-col min-h-screen bg-slate-50 text-slate-800 antialiased font-sans">
        {/* Navigation */}
        <Navbar />

        {/* Hovedindhold */}
        <main className="flex-grow">
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/ydelser" element={<Services />} />
            <Route path="/om-os" element={<About />} />
            <Route path="/priser" element={<Prices />} />
            <Route path="/kontakt" element={<Contact />} />
            <Route path="/403" element={<Forbidden />} />
            <Route path="*" element={<NotFound />} />
          </Routes>
        </main>

        {/* Footer */}
        <Footer />
      </div>
    </>
  );
}
